(function () {
  "use strict";

  var cleanupHeader = null;

  function enhanceHeader(root) {
    if (cleanupHeader) cleanupHeader();
    if (!root) return;

    var mobileToggle = root.querySelector(".js-mobile-nav-toggle");
    var searchToggle = root.querySelector("[data-predictive-search-open-drawer]");
    var submenus = root.querySelectorAll(".js-toggle-submenu[data-level]");
    var focusFrame = 0;
    var destroyed = false;
    var heightObserver = null;
    var heightProperty = "--wt-home-header-height";
    var heightStyle = document.body && document.body.classList.contains("wt-native-home")
      ? document.documentElement.style : null;
    var originalHeight = heightStyle ? heightStyle.getPropertyValue(heightProperty) : "";
    var originalHeightPriority = heightStyle ? heightStyle.getPropertyPriority(heightProperty) : "";
    var lastWrittenHeight = null;

    function syncHeaderHeight() {
      if (!heightStyle || destroyed || !root.isConnected) return;
      var height = Math.ceil(root.getBoundingClientRect().height);
      if (!Number.isFinite(height) || height <= 0) return;
      var value = height + "px";
      if (heightStyle.getPropertyValue(heightProperty) === value) return;
      heightStyle.setProperty(heightProperty, value);
      lastWrittenHeight = value;
    }

    if (heightStyle) {
      syncHeaderHeight();
      if (typeof ResizeObserver === "function") {
        heightObserver = new ResizeObserver(syncHeaderHeight);
        heightObserver.observe(root);
      } else {
        window.addEventListener("resize", syncHeaderHeight);
      }
      root.addEventListener("load", syncHeaderHeight, true);
    }

    function syncState() {
      var menuOpen = mobileToggle && mobileToggle.getAttribute("aria-expanded") === "true";
      if (root.classList.contains("wt-mobile-menu-open") !== Boolean(menuOpen)) {
        root.classList.toggle("wt-mobile-menu-open", Boolean(menuOpen));
      }

      if (mobileToggle) {
        var menuLabel = menuOpen ? mobileToggle.dataset.menuCloseLabel : mobileToggle.dataset.menuOpenLabel;
        if (mobileToggle.getAttribute("aria-label") !== menuLabel) {
          mobileToggle.setAttribute("aria-label", menuLabel);
        }
      }

      for (var index = 0; index < submenus.length; index += 1) {
        var expanded = String(Boolean(menuOpen && submenus[index].classList.contains("is-active")));
        if (submenus[index].getAttribute("aria-expanded") !== expanded) {
          submenus[index].setAttribute("aria-expanded", expanded);
        }
      }

      // Debut's search initializer accidentally replaces the target ID with "dialog".
      if (searchToggle && searchToggle.getAttribute("aria-controls") !== "SearchDrawer") {
        searchToggle.setAttribute("aria-controls", "SearchDrawer");
      }
    }

    function closeDropdown(item, restoreFocus) {
      var toggle = item.querySelector(".site-nav__link--button");
      if (!toggle || !item.classList.contains("site-nav--active-dropdown")) return;
      toggle.click();
      if (restoreFocus) toggle.focus();
    }

    function onKeyDown(event) {
      var target = event.target;
      if (!(target instanceof Element)) return;
      var item = target.closest(".site-nav--has-dropdown");
      if (!item) return;

      if (event.key === "Escape" && item.classList.contains("site-nav--active-dropdown")) {
        event.preventDefault();
        closeDropdown(item, true);
      } else if (event.key === "ArrowDown" && target.matches(".site-nav__link--button")) {
        event.preventDefault();
        if (!item.classList.contains("site-nav--active-dropdown")) target.click();
        var firstLink = item.querySelector(".site-nav__dropdown a");
        if (firstLink) firstLink.focus();
      }
    }

    function onFocusOut() {
      cancelAnimationFrame(focusFrame);
      focusFrame = requestAnimationFrame(function () {
        var activeDropdown = root.querySelector(".site-nav--active-dropdown");
        if (activeDropdown && !activeDropdown.contains(document.activeElement)) {
          closeDropdown(activeDropdown, false);
        }
      });
    }

    var observer = new MutationObserver(syncState);
    observer.observe(root, {
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "aria-controls", "aria-expanded"]
    });

    root.addEventListener("keydown", onKeyDown);
    root.addEventListener("focusout", onFocusOut);
    syncState();

    cleanupHeader = function () {
      destroyed = true;
      observer.disconnect();
      if (heightObserver) heightObserver.disconnect();
      window.removeEventListener("resize", syncHeaderHeight);
      root.removeEventListener("load", syncHeaderHeight, true);
      if (heightStyle && lastWrittenHeight !== null && heightStyle.getPropertyValue(heightProperty) === lastWrittenHeight) {
        if (originalHeight) heightStyle.setProperty(heightProperty, originalHeight, originalHeightPriority);
        else heightStyle.removeProperty(heightProperty);
      }
      cancelAnimationFrame(focusFrame);
      root.removeEventListener("keydown", onKeyDown);
      root.removeEventListener("focusout", onFocusOut);
      root.classList.remove("wt-mobile-menu-open");
      cleanupHeader = null;
    };
  }

  function initialize() {
    enhanceHeader(document.querySelector("[data-header-section]"));
  }

  document.addEventListener("shopify:section:load", function (event) {
    var root = event.target.querySelector("[data-header-section]");
    if (root) enhanceHeader(root);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    if (event.target.querySelector("[data-header-section]") && cleanupHeader) cleanupHeader();
  });

  window.addEventListener("pagehide", function () {
    if (cleanupHeader) cleanupHeader();
  });
  window.addEventListener("pageshow", initialize);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize, { once: true });
  } else {
    initialize();
  }
})();
